import { Key, useEffect } from "react";
import { useQuery } from "react-query";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import InsructionBlock from "../components/Control/InsructionBlock";
import { Loader } from "../components/UI/Loader";
import { request } from "../utils/axios-utils";
const PlusIcon = require("../assets/icons8-plus-50.png");
const SettingsIcon = require("../assets/icons8-settings-50.png");

const ControlPanel = () => {
  const {
    isLoading,
    data: response,
    refetch,
  } = useQuery("user-panel", () => {
    return request({ url: "api/v2/project/list" });
  });
  const { t } = useTranslation();

  useEffect(() => {
    refetch();
  }, []);

  if (isLoading) {
    <Loader />;
  }
  const navigate = useNavigate();
  const Navigate = (path: string) => {
    navigate(path);
  };
  return (
    <Container>
      <div className="top_box">
        <p>
          {t("controlPanelSitesQuantityText")}: {" "}
          {response?.data.length > 1
            ? response?.data.length
            : response?.data.length}
        </p>
        <Link to="create">
          <img src={PlusIcon} alt="PlusIcon" />
        </Link>
      </div>
      <div className="box">
        <List>
          {response?.data.map(
            (el: { name: string | undefined; id: Key | null | undefined }) => {
              return (
                <li key={el.id} onClick={() => Navigate(`${el.id}/update`)}>
                  <Button>{el.name}</Button>
                  <img src={SettingsIcon} alt="settings" />
                </li>
              );
            }
          )}
        </List>
      </div>
      <InsructionBlock />
    </Container>
  );
};

export default ControlPanel;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 5px;

  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border-radius: 4px;
    padding: 8px;

    :hover {
      background-color: aliceblue;
      text-decoration: underline;
    }

    img {
      height: 25px;
    }
  }
`;

const Button = styled.button`
  border: none;
  background: none;
  color: #000;
  cursor: pointer;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  & h1 {
    font-size: 24px;
    text-align: center;
  }

  .top_box {
    max-width: 36rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 2rem;
    border: none;
    outline: none;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    color: #121212;
    background: #9bc2e0;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }
    a {
      width: 32px;
      height: 32px;
    }
    img {
      height: 32px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;

      :hover {
        scale: 1.2;
      }
    }

    p {
      color: #ffffff;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .box {
    max-width: 36rem;
    min-height: 24rem;
    width: 100%;
    display: flex;
    padding: 1rem 1.5rem;
    flex-direction: column;
    gap: 10px;
    border: none;
    outline: none;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    color: #121212;
    background: #ffffff;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }
  }
`;
